let tabimages = [
    "/assets/images/instagram.svg , /assets/images/insta_tabs.svg",
    "/assets/images/TikTok.svg , /assets/images/tiktok_white.webp",
    "/assets/images/Facebook.svg , /assets/images/facebook_tabs.svg",
    "/assets/images/youtube_tabs.svg , /assets/images/youtube_white.webp",
    "/assets/images/Threads.svg , /assets/images/thread_white.webp",
    "/assets/images/Twitter.svg , /assets/images/twitter_white.webp",
];
let tabnames = [
    "instagram",
    "tiktok",
    "facebook",
    "youtube",
    "threads",
    "twitter",
];
let tabcolors = [
    "bg-inta",
    "bg-tiktok",
    "bg-face",
    "bg-youtube",
    "bg-thread",
    "bg-X",
];

let currentIndex = 1;
let currenarray = "instagram";
let homePageHeadingData = {
    instagram: [
        "Followers",
        "Views",
        "Likes",
        "Auto Likes",
        "Auto Views",
        "Story Views",
        "Comments",
        "Female Followers",
        "English Followers",
    ],
    youtube: [
        "Subscribers",
        "Short Views",
        "Watchtime",
        "Views",
        "Video Likes",
        "Video Share",
        "Views Targeted",
        "Live Stream",
    ],
    facebook: [
        "Followers",
        "Post Likes",
        "Story Views",
        "Video Views",
        "Post Likes",
        "Watch Hours",
    ],
    threads: ["Followers", "Likes"],
    tiktok: [
        "Followers",
        "Likes",
        "Views",
        "Auto Likes",
        "Comments",
        "Livestream",
        "Auto Views",
    ],
    twitter: [
        "Followers",
        "Likes",
        "Retweets",
        "Votes",
        "Views",
        "Female Followers",
        "Space Listeners",
    ],
};
let homeHeading = document.querySelector(".homepage-heading");
let myInterval;
if (homeHeading) {
    myInterval = setInterval(() => {
        homeHeading.querySelector(".span").innerText =
            homePageHeadingData[currenarray][currentIndex];
        currentIndex++;
        currentIndex = currentIndex % homePageHeadingData[currenarray].length;
    }, 1700);
}

function startInterval(category) {
    if (homeHeading) {
        clearInterval(myInterval);
        currentIndex = 1;
        currenarray = category;
        homeHeading.querySelector("span").innerText = `${
            category[0].toUpperCase() + category.slice(1)
        }`;
        homeHeading.querySelector(".span").innerText =
            homePageHeadingData[currenarray][0];
        homeHeading.querySelector(".span").classList = `${category}-text span`;
        myInterval = setInterval(() => {
            homeHeading.querySelector(".span").innerText =
                homePageHeadingData[currenarray][currentIndex];
            currentIndex++;
            currentIndex = currentIndex % homePageHeadingData[currenarray].length;
        }, 1700);
    }
}

$(document).on("click", ".tab", function () {
    let prev = $(".active-tab");
    let prevtab = prev.attr("data-tab");
    let current = $(this);
    let currenttab = current.attr("data-tab");
    startInterval(currenttab);
    tabnames.forEach((element, index) => {

        if (element == prevtab) {
            prev.removeClass(`active-tab scale-110 ${tabcolors[index]}`);
            prev.find("img").attr("src", `${BASE_URL}${tabimages[index].split(" , ")[0]}`);
        }
        if (element == currenttab) {
            current.addClass(`active-tab scale-110 ${tabcolors[index]}`);
            current.find("img").attr("src", `${BASE_URL}${tabimages[index].split(" , ")[1]}`);
        }
    });
    var tabId = current.data("tab");
    $(".tab-content").removeClass("active");
    $("#" + tabId).addClass("active");

    $("#" + tabId)
        .find("input")
        .each(function () {
            this.focus();
            const valueLength = this.value.length;
            this.setSelectionRange(valueLength, valueLength);
        });
});

// let copy = document.querySelector(".logos-slide").cloneNode(true);
// document.querySelector(".logos").appendChild(copy);

// let copy_again = document.querySelector(".logos-slide-2").cloneNode(true);
// document.querySelector(".logos-2").appendChild(copy_again);

const textElements = document.querySelectorAll(".text");
const buttons = document.querySelectorAll(".toggle-button");

// Function to calculate height of 12 lines for each section
function setTextHeight(textElement, lines) {
    const lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
    textElement.style.maxHeight = lineHeight * lines + "px";
}

// Initial setting to show 12 lines for each section
textElements.forEach((textElement) => {
    setTextHeight(textElement, 12);

    // Check if content exceeds 12 lines
    const lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
    if (textElement.scrollHeight > lineHeight * 12) {
        // Show button only if content exceeds 12 lines
        const button = buttons[Array.from(textElements).indexOf(textElement)];
        button.style.display = "block"; // Show the button
    } else {
        // Hide the button if content is less than or equal to 12 lines
        const button = buttons[Array.from(textElements).indexOf(textElement)];
        button.style.display = "none"; // Hide the button
    }
});

// Toggle functionality for each button
buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
        const textElement = textElements[index]; // Get the corresponding text element

        if (button.textContent === "More+") {
            textElement.style.maxHeight = "none"; // Allow full height
            button.textContent = "Less";
        } else {
            setTextHeight(textElement, 12); // Collapse to 12 lines
            button.textContent = "More+";
        }
    });
});

const targetElement = document.querySelector(".span");
const observer1 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            targetElement.style.fontSize = "inherit";
        } else {
            targetElement.style.fontSize = "10px";
        }
    });
});
observer1.observe(targetElement);

// const carousel = document.querySelector(".carousel"),
// 	firstVideo = carousel.querySelectorAll("video")[0];
// let isDragStart = false,
// 	isDragging = false,
// 	dragDirectionDetected = false,
// 	isHorizontal = false,
// 	prevPageX,
// 	prevPageY,
// 	positionDiffX,
// 	positionDiffY,
// 	targetVideo;
// const videos = carousel.querySelectorAll("video");
// videos.forEach((video, index) => {
// 	video.setAttribute("data-pos", index - Math.floor(videos.length / 2));
// });

// function updateVideoListeners() {
// 	if (isDragging) {
// 		videos.forEach((video) => {
// 			video.pause();
// 			video.onclick = null;
// 		});
// 		return;
// 	}
// 	const videos = document.querySelectorAll("video");
// 	videos.forEach((video) => {
// 		video.pause();
// 		video.onclick = null;
// 	});

// 	const centralVideo = document.querySelector('video[data-pos="0"]');
// 	if (centralVideo) {
// 		centralVideo.onclick = function (e) {
// 			e.preventDefault();
// 			if (centralVideo.paused) {
// 				videos.forEach((v) => v !== centralVideo && v.pause());
// 				setTimeout(() => {
// 					centralVideo.play();
// 				}, 500);
// 			} else {
// 				centralVideo.pause();
// 			}
// 		};
// 	}
// }

// updateVideoListeners();
// const autoSlide = () => {
// 	let scrollDiff = Math.abs(positionDiffX);
// 	let firstVideoWidth = firstVideo.clientWidth;

// 	if (positionDiffX > 0) {
// 		if (scrollDiff > firstVideoWidth / 3) {
// 			updateDataPos(true);
// 		}
// 	} else if (positionDiffX < 0) {
// 		if (scrollDiff > firstVideoWidth / 3) {
// 			updateDataPos(false);
// 		}
// 	}
// 	updateVideoListeners();
// };
// const dragStart = (e) => {
// 	isDragStart = true;
// 	dragDirectionDetected = false;
// 	prevPageX = e.pageX || e.touches[0].pageX;
// 	prevPageY = e.pageY || e.touches[0].pageY;
// };
// const dragging = (e) => {
// 	if (!isDragStart) return;
// 	const currentPageX = e.pageX || e.touches[0].pageX;
// 	const currentPageY = e.pageY || e.touches[0].pageY;
// 	positionDiffX = currentPageX - prevPageX;
// 	positionDiffY = currentPageY - prevPageY;
// 	if (!dragDirectionDetected) {
// 		const movementThreshold = 10;
// 		if (
// 			Math.abs(positionDiffX) > movementThreshold ||
// 			Math.abs(positionDiffY) > movementThreshold
// 		) {
// 			isHorizontal = Math.abs(positionDiffX) > Math.abs(positionDiffY);
// 			dragDirectionDetected = true;
// 		}
// 	}
// 	if (dragDirectionDetected && isHorizontal) {
// 		if (e.cancelable) e.preventDefault();
// 		isDragging = true;
// 		carousel.classList.add("dragging");

// 		targetVideo = document.querySelector('video[data-pos="0"]');
// 		if (targetVideo) {
// 			const limitedPositionDiff =
// 				Math.min(150, Math.abs(positionDiffX)) * Math.sign(positionDiffX);
// 			const rotationAngle = (
// 				(Math.sign(limitedPositionDiff) * Math.abs(limitedPositionDiff)) /
// 				10
// 			).toFixed(2);

// 			if (e.type.startsWith("touch")) {
// 				targetVideo.style.transition = "none";
// 			} else if (e.type.startsWith("mouse")) {
// 				targetVideo.style.transition = "transform 0.1s linear";
// 			}
// 			targetVideo.style.transform = `translate(${limitedPositionDiff}px,0) rotate(${rotationAngle}deg)`;
// 		}
// 	}
// };

// const dragStop = () => {
// 	isDragStart = false;
// 	carousel.classList.remove("dragging");

// 	if (!isDragging) return;
// 	isDragging = false;
// 	if (targetVideo) {
// 		targetVideo.style.transition = "";
// 		targetVideo.style.transform = "";
// 		targetVideo = null;
// 	}
// 	autoSlide();
// };

// function updateDataPos(isRightSwipe) {
// 	const videos = carousel.querySelectorAll("video");
// 	const newPosValues = [];

// 	videos.forEach((video) => {
// 		let currentPos = parseInt(video.getAttribute("data-pos"), 10);
// 		let newPos = isRightSwipe ? currentPos + 1 : currentPos - 1;
// 		if (newPos > Math.floor(videos.length / 2)) {
// 			newPos -= videos.length;
// 		} else if (newPos < -Math.floor(videos.length / 2)) {
// 			newPos += videos.length;
// 		}
// 		newPosValues.push(newPos);
// 	});

// 	videos.forEach((video, index) => {
// 		video.setAttribute("data-pos", newPosValues[index]);
// 	});
// }
// carousel.addEventListener("mousedown", dragStart);
// carousel.addEventListener("touchstart", dragStart);
// document.addEventListener("mousemove", dragging);
// carousel.addEventListener("touchmove", dragging);
// document.addEventListener("mouseup", dragStop);
// carousel.addEventListener("touchend", dragStop);

// document.addEventListener("DOMContentLoaded", () => {
//     const circles = document.querySelectorAll(".containers div");
//     let currentIndex = 0;

//     setInterval(() => {
//         circles[currentIndex].classList.remove("circle");
//         currentIndex = (currentIndex + 1) % circles.length;
//         circles[currentIndex].classList.add("circle");
//     }, 1400);
// });
let homeLogo = document.querySelector(".cirlce-logo-animation");
let circleIntervalRefrence;
const circles = document.querySelectorAll(".circle");
let radius = 175;
if (window.innerWidth < 1024) {
    radius = 140;
}
const angle = 360 / circles.length;
let count1 = -1;
setTimeout(() => {
    helper11();
}, 500);
let colorsArray = [
    "#1877f2",
    "#1da1f2",
    "#e41d76",
    "#3f3838",
    "#cd201f",
    "#c1337d",
];
function helper11(flag) {
    return circles.forEach((circle, idx) => {
        const x = Math.cos(angle * idx * (Math.PI / 180)) * radius;
        const y = Math.sin(angle * idx * (Math.PI / 180)) * radius;
        circle.style.setProperty("--angle", idx * angle + "deg");
        circle.style.transform = `translate(${x}px, ${y}px)`;
        if (idx == circles.length - 1 && !flag) {
            circle.classList.add("hover");
        } else if (idx == 0 && flag) {
            circle.classList.add("hover");
            homeLogo?.querySelectorAll(".st0")?.forEach((element) => {
                element.style.fill = colorsArray[0];
            });
        }
        if (!flag) {
            circle.addEventListener("mouseenter", function () {
                clearInterval(circleIntervalRefrence); // Stop the interval
                circles.forEach((circle) => circle.classList.remove("hover")); // Remove hover class from all circles
                count1 = idx;
                circle.classList.add("hover");
                homeLogo?.querySelector("svg")?.classList.remove("class-jello");
                homeLogo?.querySelector("svg")?.classList.remove("class-bounce");
                setTimeout(() => {
                    homeLogo?.querySelector("svg")?.classList.add("class-jello");
                }, 100);
                homeLogo?.querySelectorAll(".st0")?.forEach((element) => {
                    element.style.fill = colorsArray[idx];
                });
            });
            circle.addEventListener("mouseleave", function () {
                circleIntervalRefrence = circleInterval(); // Restart the interval when mouse leaves
            });
        }
    });
}
circleIntervalRefrence = circleInterval();

function circleInterval() {
    return setInterval(() => {
        count1 += 1;
        circles.forEach((circle) => circle.classList.remove("hover"));
        if (count1 == circles.length) {
            circles.forEach((circle) => {
                circle.style.transform = `translate(-50%, -50%)`;
                circle.style.setProperty("--angle", "0deg");
            });
            setTimeout(() => {
                helper11(true);
            }, 500);
            return;
        }
        count1 = count1 % circles.length;
        circles[count1].classList.add("hover");
        homeLogo?.querySelector("svg")?.classList.remove("class-jello");
        homeLogo?.querySelector("svg")?.classList.remove("class-bounce");
        setTimeout(() => {
            homeLogo
                ?.querySelector("svg")
                ?.classList.add(count1 % 2 == 0 ? "class-jello" : "class-bounce");
        }, 100);
        homeLogo?.querySelectorAll(".st0")?.forEach((element) => {
            element.style.fill = colorsArray[count1];
        });
    }, 3000);
}
